import { defineQuery } from 'groq';

export const loyaltyHomepageConfigWebQuery = defineQuery(`
  *[_type == "loyaltyHomepageConfigWeb" && _id == "loyaltyHomepageConfigWeb"]{
    _updatedAt,
    unauthenticatedUsers {
      ...,
      layout->,
      widgets[]->
    }
  }[0]
`);

export const loyaltyHomepageConfigAppQuery = defineQuery(`
  *[_type == "loyaltyHomepageConfigApp" && _id == "loyaltyHomepageConfigApp"]{
    ...,
    appTopImage {
      ...,
      asset-> {
        ...,
        metadata {
          blurHash
        }
      }
    },
    unauthenticatedUsers {
      ...,
      layout->,
      widgets[]->
    }
  }[0]
`);
